import { CLAIM_TYPES } from 'Data/payments.js'

export function getText(receivable) {
  return `${CLAIM_TYPES.includes(receivable.rtype) ? 'Claim' : 'Invoice'} #${receivable.human_readable_id}`
}
